import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconArrowDiagonalUpRightStyle0 = cosmosIconCss;

const CosmosIconArrowDiagonalUpRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowDiagonalUpRight extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m12.995 10.066 2.496 2.496a.3.3 0 0 0 .509-.213V6.297A.29.29 0 0 0 15.703 6H9.65a.3.3 0 0 0-.212.509l2.496 2.496-6.717 6.717a.5.5 0 0 0 0 .707l.353.354a.5.5 0 0 0 .707 0l6.718-6.718", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconArrowDiagonalUpRightStyle0; }
}, [1, "cosmos-icon-arrow-diagonal-up-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-diagonal-up-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-diagonal-up-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowDiagonalUpRight$1);
            }
            break;
    } });
}

const CosmosIconArrowDiagonalUpRight = CosmosIconArrowDiagonalUpRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowDiagonalUpRight, defineCustomElement };
